import React, { useState } from "react";

import Context from "./index";
import { loginApi } from "../Api/Login";
import { alertToastErrorFromResponse } from "../../../Shared/Utils/errorUtils";
import { genericError } from "../../../Shared/Constants";
import { alertSuccess } from "../../../Shared/Utils/alertMessages";

const AuthProvider = (props) => {
  const [loading, setLoading] = useState(false);
  const [apiErrors, setApiErrors] = useState([]);
  const [successLogin, setSuccessLogin] = useState(false);

  //Create object
  const login = async (data) => {
    try {
      setLoading(true);
      let response = await loginApi(data);
      setLoading(false);

      if (response?.result && response?.result == "success") {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("authenticated", true);
        console.log(response);

        localStorage.setItem(
          "auth0_profile",
          JSON.stringify(response.data.user)
        );
        localStorage.setItem(
          "permissions",
          JSON.stringify(response.data.permissions)
        );

        alertSuccess("Login exitoso!");
        setSuccessLogin(true);
        window.location.href = `${process.env.PUBLIC_URL}/app/contacts`;
        setApiErrors([]);
      } else {
        alertToastErrorFromResponse("Error iniciando sesion", response);
      }
    } catch (e) {
      console.error("Error login", e);
      setLoading(false);
      setApiErrors([e.message]);
      alertToastErrorFromResponse(genericError, e);
    }
  };
  return (
    <Context.Provider
      value={{
        ...props,
        login,
        loading,
        apiErrors,
        successLogin,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};
export default AuthProvider;
